/**
 * Regexp to match only Safari browsers.
 *
 * Note that the Chrome UA and legacy Android stock browser contain the word
 * "Safari" in their user agent, so we're explicitly excluding these two
 * browsers.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 *
 */
const SAFARI_REGEXP = /^((?!chrome|android).)*safari/i;

/**
 * This function returns a custom `X-Auth` header only for Safari, otherwise it
 * returns the standard `Authorization` header.
 * Safari doesn't properly send XHR requests having an `Authorization` header.
 * More context in this Slack thread: https://zapier.slack.com/archives/CD4LXLTK5/p1594289894336000
 *
 * This function can help to build an XHR request with credentials like so:
 *
 * ```
 * fetch(url, {
 *   credentials: 'same-origin',
 *   headers: {
 *     [getAuthorizationHeader()]: 'Bearer xxx'
 *   }
 * })
 * ```
 */
export default function getAuthorizationHeader(
  userAgent = navigator.userAgent
) {
  return SAFARI_REGEXP.test(userAgent) ? 'X-Auth' : 'Authorization';
}
